import { SerializableObjectSchema } from '../../../../../objects/generic/serialization/serializable-object-schema';
import { CommunicationsRequestName } from '../../../communications-request-name';
import { CommunicationsResponse } from '../../generic/communications-response/communications-response';
import { CommunicationsResponseSchema } from '../../generic/communications-response/communications-response-schema';

import { CommunicationsResponseOnVrcAudioUpdateConstructor } from './communications-response-on-vrc-audio-update-constructor';
import { CommunicationsResponseOnVrcAudioUpdateError } from './communications-response-on-vrc-audio-update-error';
import { CommunicationsResponseOnVrcAudioUpdateSchema } from './communications-response-on-vrc-audio-update-schema';

export class CommunicationsResponseOnVrcAudioUpdate extends CommunicationsResponse<CommunicationsResponseOnVrcAudioUpdateError> {
  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////
  constructor(parameters: CommunicationsResponseOnVrcAudioUpdateConstructor) {
    super({
      ...parameters,
      [CommunicationsResponseSchema.type]: CommunicationsRequestName.onVrcAudioUpdate,
    });
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  /**
   * This static function is private, and meant to be called only by
   * SerializableObject, and subclasses
   *
   * @param validationResult
   */
  protected static _deserialize(
    validationResult: import('joi').ValidationResult,
  ): CommunicationsResponseOnVrcAudioUpdate {
    return new CommunicationsResponseOnVrcAudioUpdate(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////
  public serialize() {
    return super.serialize(CommunicationsResponseOnVrcAudioUpdate.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////
  public static getSchema(): SerializableObjectSchema {
    return new CommunicationsResponseOnVrcAudioUpdateSchema();
  }
}
